import React from 'react';
import styles from './Error.module.scss';

type ErrorProps = {
  touched: boolean;
  error: string;
};

export default function Error({ touched, error }: ErrorProps) {
  if (touched && error) {
    return (<div className={styles.error}>{error}</div>);
  }
}
